export default __webpack_public_path__ + "static/media/Email_Configuration_Icon.a120fbde.svg";